document.addEventListener('DOMContentLoaded', function() {
  const selector = document.querySelector('[data-size-selector]');
  if (!selector) return;

  const btns = selector.querySelectorAll('.size-btn');
  const priceEl = document.querySelector('[data-size-price]');
  const form = document.querySelector('form[action="/cart/add"]');

  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      btns.forEach(function(b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
      if (priceEl) priceEl.textContent = this.dataset.price;
      const variantInput = form ? form.querySelector('input[name="id"]') : null;
      if (variantInput) variantInput.value = this.dataset.variantId;
    });
  });
});
